module.exports = __webpack_public_path__ + "images/category_lp/watch/omega/assessment_achievements/5_9bf7acc7358f2277f08b68540232a2c0.png";